import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';
import BodyAside from './BodyAside';
import topBox from './topBox';

const twoColumns: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 'twoColumns',
  mx: 'auto',
  gap: spacing(3),
  px: 3,

  '.twoColumns__topBox': topBox,

  '.twoColumns__section': {
    display: 'flex',
    gap: spacing(3),
    alignItems: 'start',

    '.twoColumns__main': {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      pb: '60px',

      '#BodyAside': BodyAside,
    },

    '.twoColumns__aside': {
      position: 'sticky',
      top: 3,
      width: 'applicationMenu',
      flexShrink: 0,
      flexGrow: 0,

      display: responsive({ 0: 'none', 4: 'block' }),
    },
  },
};

export default twoColumns;
